module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/campus-managers-5b633bd774270596a6f1dea272f06466.jpg";